import { useQuery } from "react-query";
import { useRouter } from "../../useRouter";
import { useApiError } from "src/hooks/useApiError";
import { getCountryCode } from "src/service/pay";
import { useState } from "react";
import { ProductKey } from "src/config/config";
import { useSearchParams } from "react-router-dom";
import { localStrings } from "src/utils/localization";

interface IUseTotalNxacListProps {
  product: ProductKey;
  status?: "REAL" | "TEST";
  // currency: string; // 원화 정보
  onSuccess?: () => void;
  onError?: () => void;
}
// 제품별 요금제 정보
export function useGetCurrencyCode({
  product,
  status = "REAL",
  onSuccess,
  onError,
}: IUseTotalNxacListProps) {
  const { handleError } = useApiError();
  const [params, setParams] = useSearchParams();
  const { goConsole, lang } = useRouter();
  // 상품별 요금제 정보
  // const [isPriceListLoading, setIsPriceListLoading] = useState<boolean>(true);
  const [currency, setCurrency] = useState<string>("WON");
  const [payCompany, setPayCompany] = useState<"INICIS" | "PAYPAL">("INICIS"); // INICIS & PAYPAL
  const {
    isLoading: isPriceListLoading,
    data: countryCode,
    refetch: priceListRefetch,
  } = useQuery(
    ["getCurrenctCode", lang],
    async () =>
      await getCountryCode({
        countryCode: lang === "ko" ? "KR" : "US",
        languageCode: lang === "ko" ? "KR" : "US",
      }),
    {
      enabled: product !== null,
      // refetchOnMount: true,
      onSuccess: onSuccess
        ? onSuccess
        : (res) => {
            if (res.countryCode === "KR") {
              setCurrency("WON");
              setPayCompany("INICIS");
            } else {
              setCurrency("US");
              setPayCompany("PAYPAL");
            }
          },
      onError: onError ? onError : handleError,
    }
  );

  return { currency, payCompany, countryCode };
}
